const { Storage } = window.o_global;
function storage(storageObjectOrFunction) {
  return new Storage(storageObjectOrFunction);
}

export { Storage, storage };
/*                                */
